import React from 'react';

/**
 * Landmark for the active protected page. Keep application chrome such as the
 * header and sidebar outside this wrapper; route content belongs inside it.
 */
const MainContent = ({ children, className }) => (
    <main className={className}>
        {children}
    </main>
);

export default MainContent;
